export default "__VITE_ASSET__e637e370__"